<template>
	<v-card>
		<v-container fluid>
			<div class="d-flex flex-wrap mb-3" style="gap: 10px">
				<v-dialog max-width="1400px" width="100%">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" outlined v-on="on" v-bind="attrs">
							<v-icon left>mdi-file-document-edit-outline</v-icon>Ver el contrato
						</v-btn>
					</template>
					<DetallesContrato
						:_codigoContrato="data.CodigoContrato"
						:_idContrato="data.IdContrato"
						class="pa-0"
					/>
				</v-dialog>
				<v-dialog max-width="1400px" width="100%">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" outlined v-on="on" v-bind="attrs">
							<v-icon left>mdi-account</v-icon>Ver el cliente
						</v-btn>
					</template>
					<DetallesCliente :_idCliente="data.IdCliente" class="pa-0" />
				</v-dialog>
			</div>
			<v-row>
				<!-- <v-col cols="12" md="4" style="position: relative">
				<div class="sticky py-4">-->

				<!-- <text-editor class="mt-6" v-model="msg" />
						<div class="d-flex flex-wrap my-1" style="gap: 4px">
							<v-chip v-for="f in files" label>
								<v-icon left>mdi-attachment</v-icon>
								{{ f.name }}
							</v-chip>
				</div>-->

				<!-- <div class="d-flex">
							<v-spacer />
							<v-chip label class="mr-2 my-auto">
								<v-icon small left>mdi-paperclip</v-icon>
								{{ files.length }} adjuntos
								<v-icon v-if="files.length" small right @click="files = []">mdi-close</v-icon>
							</v-chip>
							<v-btn outlined color="primary" @click="send">
								enviar
								<v-icon right>mdi-send</v-icon>
							</v-btn>
				</div>-->

				<!-- <v-row class="ma-2">
							<v-col cols="12">
								<v-subheader>Adjuntar archivos</v-subheader>
								<DragAndDrop @aceptar="(v) => files = v" />
							</v-col>
				</v-row>-->
				<!-- </div>
				</v-col>-->

				<v-col cols="12" md="6" style="height: 100%; overflow-y: auto">
					<tarjeta-datos header icon="currency-eur-off">
						<template v-slot:titulo>
							Mensajes Impagado
							<v-btn class="ml-auto" small color="primary" @click.stop="getInfo">
								<v-icon left>mdi-refresh</v-icon>Recargar
							</v-btn>
						</template>
						<v-timeline dense>
							<v-slide-x-transition group>
								<mensaje-timeline
									v-for="(message, i) in data.mensajes"
									:message="message"
									:key="i"
									@reload="getInfo"
									small
								></mensaje-timeline>
								<nuevo-mensaje-timeline
									:key="newMessageImp.show"
									v-show="newMessageImp.show"
									v-model="newMessageImp"
								/>
							</v-slide-x-transition>
						</v-timeline>
						<v-btn
							v-if="!newMessageImp.show"
							class="ml-2 mb-2"
							small
							color="primary"
							@click.stop="newMessageImp.show = true"
						>
							<v-icon left>mdi-plus</v-icon>nuevo mensaje
						</v-btn>
						<template v-else>
							<v-btn class="ml-2 mb-2" small color="primary" @click.stop="send">
								<v-icon left>mdi-send</v-icon>enviar
							</v-btn>
							<v-btn
								class="ml-2 mb-2"
								small
								color="error"
								@click.stop="newMessageImp.show = false; newMessageImp.msg = null"
							>
								<v-icon left>mdi-close</v-icon>cancelar
							</v-btn>
						</template>
					</tarjeta-datos>
				</v-col>

				<v-col cols="12" md="6">
					<tarjeta-datos header icon="account">
						<template v-slot:titulo>
							Notas Cliente
							<v-btn class="ml-auto" small color="primary" @click.stop="getInfo">
								<v-icon left>mdi-refresh</v-icon>Recargar
							</v-btn>
						</template>
						<v-timeline dense>
							<v-slide-x-transition group>
								<mensaje-timeline
									v-for="(message, i) in data.mensajesCliente"
									:message="message"
									:key="i"
									small
									@reload="getInfo"
								></mensaje-timeline>
								<nuevo-mensaje-timeline
									:key="newMessage.show"
									v-show="newMessage.show"
									v-model="newMessage"
								/>
							</v-slide-x-transition>
						</v-timeline>
						<v-btn
							v-if="!newMessage.show"
							class="ml-2 mb-2"
							small
							color="primary"
							@click.stop="newMessage.show = true"
						>
							<v-icon left>mdi-plus</v-icon>nuevo mensaje
						</v-btn>
						<template v-else>
							<v-btn class="ml-2 mb-2" small color="primary" @click.stop="sendNewMessage">
								<v-icon left>mdi-send</v-icon>enviar
							</v-btn>
							<v-btn
								class="ml-2 mb-2"
								small
								color="error"
								@click.stop="newMessage.show = false; newMessage.msg = null"
							>
								<v-icon left>mdi-close</v-icon>cancelar
							</v-btn>
						</template>
					</tarjeta-datos>
				</v-col>

				<v-col cols="12" md="4">
					<tarjeta-datos header titulo="Datos de contacto" icon="phone" :datos="contactos" />
				</v-col>

				<v-col cols="12" md="4">
					<tarjeta-datos
						header
						titulo="Historial estados"
						icon="format-list-bulleted"
						:datos="historialEstados"
					/>
					<div class="mt-2">
						<v-select
							clearable
							filled
							dense
							hide-details
							:items="data.estados"
							item-text="estado"
							return-object
							v-model="nuevoEstado"
							label="Seleccionar nuevo estado"
						>
							<template v-slot:append-outer>
								<v-btn @click="setEstado" class="mt-n2" color="primary">Guardar nuevo Estado</v-btn>
							</template>
						</v-select>
					</div>
				</v-col>

				<v-col cols="12" md="4">
					<tarjeta-datos
						header
						titulo="Comercial"
						icon="account-tie"
						:datos="[
							{ nombre: 'Canal/Agente', valor: data.CanalAgente },
							{ nombre: 'SubAgente', valor: data.SubAgente },
							{ nombre: 'Correo', valor: data.Correo },
							{ nombre: 'Telefono', valor: data.telefono },
							{ nombre: 'Portal', valor: data.empresa.toUpperCase() }
						]"
					/>
				</v-col>

			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { parseDate, decode64 } from "@/utils/index.js";

export default {
	components: {
		TextEditor: () => import("@/components/TextEditor.vue"),
		DetallesContrato: () => import("@/views/contratos/DetallesContrato.vue"),
		DetallesCliente: () => import("@/views/clientes/DetallesCliente.vue"),
		TarjetaDatos: () => import("@/components/TarjetaDatos.vue"),
		DragAndDrop: () => import("@/components/DragAndDrop.vue"),
		MensajeTimeline: () => import("@/components/MensajeTimeline.vue"),
		NuevoMensajeTimeline: () => import("@/components/NuevoMensajeTimeline.vue"),
	},
	props: {
		IdCarteraCobro: String,
	},
	data() {
		return {
			data: {},
			estado: "",
			interval: null,
			contactos: [],
			historialEstados: [],
			nuevoEstado: null,
			newMessageImp: {
				show: false,
				files: [],
				msg: null,
			},
			newMessage: {
				show: false,
				files: [],
				msg: null,
			},
		};
	},
	methods: {
		parseDate,
		decode64,
		getInfo() {
			return new Promise(async resolve => {
				const { data } = await axios({
					url: `${process.env.VUE_APP_OUR_API_URL}/impagados.php`,
					method: 'GET',
					params: {
						token: this.$store.getters.getJwtEmpresa,
						IdCarteraCobro: this.IdCarteraCobro
					}
				});

				const list_to_tree = (list) => {
					let map = {}, roots = [], i;

					for (i = 0; i < list.length; i += 1) {
						map[list[i].idMensaje] = i; // initialize the map
						list[i].children = []; // initialize the children
					}


					list.forEach(node => {
						if (node.idParent && node.idParent != '0') {
							// if you have dangling branches check that map[node.parentId] exists
							list[map[node.idParent]].children.push(node);
						} else {
							roots.push(node);
						}
					})

					return roots;
				}

				data.mensajes = list_to_tree(data.mensajes)
				data.mensajesCliente = list_to_tree(data.mensajesCliente)
				this.data = data;

				this.historialEstados = [];
				this.nuevoEstado = null
				this.data.historialEstados.forEach((c) => {
					this.historialEstados.push({ nombre: c.estado, valor: parseDate(c.fechaCambio, false, true, true) })
				})
				resolve();
			})
		},
		async setEstado() {
			await axios({
				url: `${process.env.VUE_APP_OUR_API_URL}/impagados.php`,
				method: 'PUT',
				data: {
					IdCarteraCobro: this.IdCarteraCobro,
					nuevoEstado: this.nuevoEstado.idEstadoImpagado,
					token: this.$store.getters.getJwtEmpresa
				}
			})

			this.getInfo();
			this.$emit('reload');
		},
		send() {
			const formData = new FormData();
			formData.append('token', this.$store.getters.getJwtEmpresa);
			formData.append('IdCarteraCobro', this.IdCarteraCobro);
			formData.append('mensaje', this.newMessageImp.msg);
			for (let i = 0; i < this.newMessageImp.files.length; i++) {
				formData.append("documentos[]", this.newMessageImp.files[i]);
			}
			axios({
				method: "POST",
				url: `${process.env.VUE_APP_OUR_API_URL}/mensajesImpagados.php`,
				data: formData,
			})
				.then(({ data }) => {
					this.newMessageImp.show = false;
					this.newMessageImp.msg = "";
					this.newMessageImp.files = [];
					this.getInfo();
				})
				.catch((err) => console.error(err));
		},
		sendNewMessage() {
			const formData = new FormData();
			formData.append('token', this.$store.getters.getJwtEmpresa);
			formData.append('IdCliente', this.data.IdCliente);
			formData.append('mensaje', this.newMessage.msg);
			for (let i = 0; i < this.newMessage.files.length; i++) {
				formData.append("documentos[]", this.newMessage.files[i]);
			}
			axios({
				method: "POST",
				url: `${process.env.VUE_APP_OUR_API_URL}/mensajesImpagados.php`,
				data: formData,
			})
				.then(({ data }) => {
					this.newMessage.show = false;
					this.newMessage.msg = "";
					this.newMessage.files = [];
					this.getInfo();
				})
				.catch((err) => console.error(err));
		},
	},
	async mounted() {
		await this.getInfo();

		// this.interval = setInterval(() => {
		// 	this.getInfo();
		// }, 30 * 1000);

		this.contactos.push({ nombre: 'Nombre', valor: this.data.RazonSocialTitular || [this.data.NombreTitular, this.data.Apellido1Titular, this.data.Apellido2Titular].filter((i) => !!i).join(' ') },)

		this.data.contactos.forEach((c) => {
			const getTipo = (tipo) => {
				switch (tipo) {
					case 'M':
						return 'Móvil'
					case 'E':
						return 'Email'
					case 'F':
					case 'T':
						return 'Fijo'
					default:
						return '';
				}
			}
			this.contactos.push({ nombre: getTipo(c.TipoContacto), valor: c.Valor })
		})
	},
	beforeDestroy() {
		// clearInterval(this.interval);
	},
};
</script>

<style>
.sticky {
	position: sticky;
	top: 0;
}
</style>